<template>
  <div class="container">
    <div class="itembox" v-for="(item, index) in list" :key="index">
      <div class="item">
        <div>
          <span class="gray">患者姓名：</span>
          <span>{{ item.real_name }}</span>
          <span class="del" v-if="item.is_delete">已删</span>
        </div>
        <div>
          <span class="gray">性别：</span>
          <span v-if="item.sex == 1">男</span>
          <span v-if="item.sex == 2">女</span>
        </div>
        <div>
          <span class="gray">关系：</span>
          <span>
            （患者是用户的）
            <span v-if="item.relationship == 1">本人</span>
            <span v-if="item.relationship == 2">爸爸</span>
            <span v-if="item.relationship == 3">妈妈</span>
            <span v-if="item.relationship == 4">老公</span>
            <span v-if="item.relationship == 5">老婆</span>
            <span v-if="item.relationship == 6">女儿</span>
            <span v-if="item.relationship == 7">儿子</span>
            <span v-if="item.relationship == 8">朋友</span>
            <span v-if="item.relationship == 9">家人</span>
          </span>
        </div>
      </div>
      <div class="item">
        <div>
          <span class="gray">出生日期：</span>
          <span>{{ item.birthday }}</span>
        </div>
        <div>
          <span class="gray">年龄：</span>
          <span>{{ item.age }}</span>
        </div>
        <div>
          <span class="gray">证件类型：</span>
          <span>{{ item.id_card_type | idCardTypeText }}</span>
        </div>
        <div>
          <span class="gray">身份证号：</span>
          <span>{{ item.id_card }}</span>
        </div>
      </div>
      <div class="item">
        <div style="width: 100%">
          <span class="gray">既往病史：</span>
          <span style="diplay: inline-block">{{ item.history_name }}</span>
        </div>
      </div>
      <div class="item">
        <div style="width: 100%">
          <span class="gray">过敏历史：</span>
          <span>{{ item.allergen_name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import patient from "../../../api/patient";
export default {
  data() {
    return {
      list: [],
    };
  },
  filters: {
    idCardTypeText(val) {
      switch (val) {
        case 1:
          return "大陆身份证";
        case 2:
          return "香港身份证";
        case 3:
          return "澳门身份证";
        default:
          return "-";
      }
    },
  },
  methods: {
    getDetail() {
      let data = {
        user_id: this.$route.query.user_id,
        page: 1,
        pageNumber: 100,
      };
      patient
        .userPatientList(data)
        .then((res) => {
          if (res.code == 0) {
            this.list = res.data.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.container {
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
}
.itembox {
  width: 100%;
  padding: 20px 20px 8px;
  box-sizing: border-box;
  border: solid 2px #e1e3e9;
  margin-bottom: 12px;
}
.item {
  display: flex;
  margin-bottom: 12px;
  div {
    width: 260px;
  }
}
.gray {
  color: #747981;
}
.del {
  font-size: 12px;
  color: #f24b2f;
  padding: 3px 5px;
  display: inline-block;
  background-color: #ffe4dd;
  border-radius: 2px;
  margin-left: 10px;
}
</style>